import {
    CHANGE_OPEN_FILTER,
    CHANGE_OPEN_HEADER_MENU,
    CHANGE_SHOW_CATALOG_MENU,
    CHANGE_SHOW_CATALOG_MENU_MOBILE,
    FIX_BODY,
    SHOW_GLOBAL_LOADER,
    SET_FAVORITE_PAGE,
    SET_ROBOTS,
    SET_IS_BRANCH_SELECTED,
} from "@/store/mutation-types";

import { CHECK_ROBOTS } from "../action-types";

const state = {
    globalLoader: false,
    fixBody: false,
    showCatalogMenu: false,
    showCatalogMenuMobile: false,
    openHeaderMenu: false,
    showFilter: false,
    showFavoritePage: false,
    robots: false,
    isBranchSelected: false,
};

const getters = {
    showFavoritePage: state => state.showFavoritePage,
    fixBody: state => state.fixBody,
    showCatalogMenu: state => state.showCatalogMenu,
    showCatalogMenuMobile: state => state.showCatalogMenuMobile,
    globalLoader: state => state.globalLoader,
    openHeaderMenu: state => state.openHeaderMenu,
    showFilter: state => state.showFilter,
    robots: state => state.robots,
    isBranchSelected: state => state.isBranchSelected,
};

const mutations = {
    [SET_FAVORITE_PAGE](state, status) {
        state.showFavoritePage = status;
    },
    [SHOW_GLOBAL_LOADER](state, status) {
        state.globalLoader = status;
    },
    [FIX_BODY](state, param) {
        const body = document.querySelector("body");
        if (param) {
            body.classList.add("fix");
        } else {
            body.classList.remove("fix");
        }
        state.fixBody = param;
    },
    [CHANGE_SHOW_CATALOG_MENU](state, status) {
        state.showCatalogMenu = status;
    },
    [CHANGE_SHOW_CATALOG_MENU_MOBILE](state, status) {
        state.showCatalogMenuMobile = status;
    },
    [CHANGE_OPEN_HEADER_MENU](state, status) {
        state.openHeaderMenu = status;
    },
    [CHANGE_OPEN_FILTER](state, status) {
        state.showFilter = status;
    },
    [SET_ROBOTS](state, status) {
        state.robots = status;
    },
    [SET_IS_BRANCH_SELECTED](state, status) {
        state.isBranchSelected = status;
    },
};

const actions = {
    [CHECK_ROBOTS]: async ({ commit }) => {
        const robotUserAgents = [
            "Googlebot",
            "Bingbot",
            "Slurp",
            "DuckDuckBot",
            "Baiduspider",
            "YandexBot",
            "Sogou",
            "HeadlessChrome",
            "Prerender",
        ];

        const userAgent = navigator.userAgent;
        const isRobot = robotUserAgents.some(robotAgent => userAgent.includes(robotAgent));

        commit("SET_ROBOTS", isRobot);
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
